module.exports = __webpack_public_path__ + "static/media/console_icon.19e87bd0.jpg";